import { render } from "./product-config.vue?vue&type=template&id=5ad0ca4b&lang=html"
import script from "./product-config.vue?vue&type=script&lang=js"
export * from "./product-config.vue?vue&type=script&lang=js"

import "./product-config.vue?vue&type=style&index=0&id=5ad0ca4b&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__